import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom'; // <-- IMPORT THIS
import './App.css';

// Import your new Layout and Page components
import Layout from './components/Layout';
import Home from './pages/Home';
import Services from './pages/Services';
import Projects from './pages/Projects';
import AboutUs from './pages/AboutUs';
import Contact from './pages/Contact';
import FAQ from './pages/FAQ';

function App() {
  const [theme, setTheme] = useState('dark');

  // Function to toggle theme
  const toggleTheme = () => {
    setTheme(theme === 'dark' ? 'light' : 'dark');
  };

  // Your existing theme effect
  useEffect(() => {
    document.body.setAttribute('data-theme', theme);
  }, [theme]);
  
  return (
    // The app-container is still the main wrapper
    <div className="app-container">
      {/* Routes defines all your possible pages */}
      <Routes>
        {/* This is a "Layout Route". 
            It renders the Layout component for all child routes.
            We pass the theme props here. */}
        <Route 
          path="/" 
          element={<Layout toggleTheme={toggleTheme} currentTheme={theme} />}
        >
          {/* These are the "child" routes that render inside the Layout's <Outlet /> */}
          
          {/* 'index' means this is the default route for "/" */}
          <Route index element={<Home />} /> 
          
          <Route path="services" element={<Services />} />
          <Route path="projects" element={<Projects />} />
          <Route path="about" element={<AboutUs />} />
          <Route path="contact" element={<Contact />} />
          <Route path="faq" element={<FAQ />} />
          
          {/* You can add a 404 "Not Found" page here later if you want */}
          {/* <Route path="*" element={<NotFound />} /> */}
        </Route>
      </Routes>
    </div>
  );
}

export default App;